import { atomWithStorage } from 'jotai/utils';

export const ORGANISATION_STORAGE_KEY = 'precifield.ghostOrganisation';
export const organisationAtom = atomWithStorage<number[]>(
  ORGANISATION_STORAGE_KEY,
  [],
);
